import { Box, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useMeetingStore } from '../../store/meeting.store'
import { useSocketsContext } from '../../contexts/sockets.context'
import { useParams } from 'react-router-dom'
import { observer } from 'mobx-react'
import { debounce } from '../../utils/utilities'
import InteractiveVirtualboard from '../virtualboard/InteractiveVitualboard'
import ReadOnlyVirtualBoard from '../virtualboard/ReadOnlyVitualboard'
import { useVirtualboardStore } from '../../store/virtualboard.store'
import { useOnlineSessionsSocketStore } from '../../store/onlinesessionsocket.store'


const VirtualboardManager = observer( () => {

    const [pressed, setPressed] = useState( false )
    const [tool, setTool] = useState( '' )
    const cursorPoints = useRef( [] )
    const toolAndPressesRef = useRef( { tool: '', pressed: false } )

    // const {  onEvent, emitEvent } = useSocketsContext()
    const OnlineSessionSocketStore = useOnlineSessionsSocketStore()

    const { meeting_id } = useParams()
    const { theme } = useTheme()

    const VirtualboardStore = useVirtualboardStore()
    const MeetingStore = useMeetingStore()


    const handleChangeOnVirtualBoard = ( event, data ) => {
        console.log( event )

        if ( event.type === "zoom-and-pan" ) {
            OnlineSessionSocketStore.emit( "virtualboard:event", { event, room_id: meeting_id, presentation_id: MeetingStore.getPresentingDocument.id, page_id: data.pageId } )
        } else if ( event.type === "slide-change" ) {
            const { newSlideIndex, pageId } = event
            OnlineSessionSocketStore.emit( "virtualboard:slide-change", { new_slide_index: newSlideIndex, room_id: meeting_id, presentation_id: MeetingStore.getPresentingDocument.id, page_id: pageId } )
        } else {
            // OnlineSessionSocketStore.emit( "virtualboard:event", { event, room_id: meeting_id, presentation_id: MeetingStore.getPresentingDocument.id, elements: data.elements, page_id: data.pageId } )
            OnlineSessionSocketStore.emit( "virtualboard:event", { event, room_id: meeting_id, presentation_id: MeetingStore.getPresentingDocument.id, page_id: data.pageId } )
        }
    }

    const debouncedMouseMoveHandler = debounce( "mouse-move-event-emitter", ( position, tool, pressed ) => {
        OnlineSessionSocketStore.emit( "virtualboard:mouse-move", { room_id: meeting_id, position, tool, pressed } )
    }, 100 )

    const handleMouseMoveOnVirtualBoard = ( position, tool, pressed ) => {
        debouncedMouseMoveHandler( position, tool, pressed )
    }

    useEffect( () => {

        const handleMouseMoveOnVirtualBoard = ( { position, user, tool: newTool, pressed: newPressed } ) => {

            cursorPoints.current.push( position )
            if ( cursorPoints.current.length > 100 )
                cursorPoints.current.shift()
            if ( toolAndPressesRef.current.tool !== newTool )
                setTool( newTool )
            setPressed( newPressed === 'pressed' )
        }

        const handleSlideChange = ( { new_slide_index, page_id } ) => {
            const document = MeetingStore.getPresentingDocument
            document.currentSlide = new_slide_index
            document.currentSlideId = page_id
            MeetingStore.setPresentingDocument( document )
            VirtualboardStore.setBoardState( {
                currentSlide: new_slide_index,
                currentSlideId: page_id,
            } )
        }


        const unsubVbCursorMoveEvent = OnlineSessionSocketStore.on( 'virtualboard:cursor:move', handleMouseMoveOnVirtualBoard )
        const unsubVbSlideChangeEvent = OnlineSessionSocketStore.on( 'virtualboard:slide-change', handleSlideChange )

        return () => {

            unsubVbSlideChangeEvent()
            unsubVbCursorMoveEvent()

        }
    }, [MeetingStore, OnlineSessionSocketStore] )

    console.log( VirtualboardStore.getBoardState )



    return (
        <Box height="100%" width="100%">
            {MeetingStore.getMeetingState.activePresenter?.user_id === MeetingStore.getLocalUser.user_id ?
                <InteractiveVirtualboard onMouseMove={handleMouseMoveOnVirtualBoard} elements={MeetingStore.presentedDocElements} onChange={handleChangeOnVirtualBoard} theme={theme} document={MeetingStore.getPresentingDocument} /> :
                <ReadOnlyVirtualBoard elements={VirtualboardStore.getElements ?? []} board={MeetingStore.getReadOnlyZoomAndPan} bgImage={MeetingStore.getPresentingDocument.slides[MeetingStore.getPresentingDocument.currentSlide].url} lastHundredCursorPoints={cursorPoints} pressed={pressed} tool={tool} />
            }
        </Box>
    )
} )

export default VirtualboardManager
